import { OrganizationSource, OrganizationSourceOptions } from 'scenes/Dashboard/data/organizations/types'
import { Deal } from 'scenes/Dashboard/data/deals/types'

export type DealInfoFormData = Pick<Deal, 'receivedOn' | 'notes'> & {
  source: {
    label: string
    value: OrganizationSource
  }
}

export function mapDealInfoToFormValues({ source, ...formData }: Pick<Deal, 'receivedOn' | 'notes' | 'source'>) {
  const formSource = OrganizationSourceOptions.find((option) => option.value === source) || OrganizationSourceOptions[0]
  return {
    source: formSource,
    ...formData,
  }
}

export function mapFormValuesToDealInfo({ source, ...dealData }: DealInfoFormData) {
  return {
    source: source.value,
    ...dealData,
  }
}
